//#region src/variants/variants_toggle.js
var variants_toggle_default = {
	default: {
		slots: { default: { initialValue: "Label" } },
		props: { labelClass: { initialValue: "d-pie-100" } }
	},
	"hide label": {
		props: { showLabel: { initialValue: false } },
		slots: { default: { initialValue: "Label" } }
	}
};
//#endregion
export { variants_toggle_default as default };

//# sourceMappingURL=variants_toggle.js.map